<template>
  <div v-if="bodyShow" class="ms-information">
    <div class="ms-infor">
      <h2 class="h2">{{result.title}}</h2>
      <h3 class="h3">{{result.description}}</h3>
      <div v-for="(item,index) in component" :key="index">
        <!-- 输入框 -->
        <div v-if="item.type=='text'" class="infor-group">
            <h4  class="h4">{{item.title}}</h4>
            <input :disabled="!item.fillable" type="text" :placeholder="`请填写你的姓名${item.required?'（必填）':''}`" @input="validationHandle()" v-model="userInfo[item.name]" />
        </div>
        <!-- 输入框数字 -->
        <div v-if="item.type=='number'" class="infor-group">
            <h4 class="h4">{{item.title}}</h4>
            <input :disabled="!item.fillable" type="text" :placeholder="`请填写你的电话号码${item.required?'（必填）':''}`" @input="validationHandle()" v-model.number="userInfo[item.name]" />
        </div>
        <!-- checkbox -->
        <div class="checkbox" v-if="item.type=='multiple'">
          <div  class="familiarity">
            <h4 class="h4">{{item.title}}</h4>
            <div v-for="(cItem,cIndex) in item.option" :key="cIndex" class="checkbox-group">
                <label :class="['icon',userInfo[item.name]&&userInfo[item.name].includes(cItem)?'on':'']" :for="cItem">
                    <input :id="cItem" type="checkbox" @change="checkboxChange(item.name,cItem)" :value="cItem" />
                </label>
                <label class="checkbox-text" :for="cItem">{{cItem}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提交 -->
    <div class="submit-group">
      <a :class="['submitBtn',bool?'on':'']" @click="saveFrom()">提交</a>
    </div>
  </div>
</template>

<script>

import { shengya_lead,shengya_submit } from "@/api/other";
import { deepCopy } from "@u/tools";
export default {
  data() {
    return {
      bodyShow:false,
      result:{},
      userInfo: {},
      component:[],
      options: {}, //选项
      bool: false //必填验证
    };
  },
  methods: {
    checkboxChange(name,val){
        this.$forceUpdate();
        // 判断数组是否有元素
        if(this.userInfo[name] && this.userInfo[name].length>0){
            // 判断数组内是否存在这个元素
            if(this.userInfo[name].includes(val)){
                // 取得这个元素的下标
                let idx = this.userInfo[name].indexOf(val);
                // 删除这个元素
                this.$delete(this.userInfo[name],idx);
            }else{
                // 添加这个元素
                this.userInfo[name].push(val);
            }
        }else{
            this.userInfo[name] = [];
            // 添加这个元素
            this.userInfo[name].push(val);
        }
        this.validationHandle();
    },
    /*
     *@param:
     *@return:
     *@Description: 提交表单
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 12:19:44
     */
    saveFrom() {
      if (!this.bool) {
        this.$toast("必填项不能为空！");
        return;
      }
      // loading
      //调用加载中
      this.$emit('loadingHandle',true,"提交中...");
      let u = deepCopy(this.userInfo);
      for(let i=0;i<this.component.length;i++){
        let item = u[this.component[i].name];
        if(item instanceof Array){
            u[this.component[i].name] = item.join(',');
        }
      }



      u['form_id'] = this.result.form_id;
      shengya_submit(u).then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return;
        }
        //关闭加载中
        this.$emit('loadingHandle',false);
        this.$toast('提交成功！');
      }).catch(()=>{
        //关闭加载中
        this.$emit('loadingHandle',false);
      });
    },
    /*
     *@param:
     *@return:
     *@Description: 验证数据是否为空
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-13 12:09:34
     */
    validationHandle() {
      let u = this.userInfo;
      let b = true;
      for(let i=0;i<this.component.length;i++){
        let item = u[this.component[i].name];
        if(this.component[i].required  && !item){
            b= false;
            break;
        }
        if(item instanceof Array && item.length==0){
            b= false;
            break;
        }
      }
      this.bool = b;
     
    },
    /*
     *@Description: 初始化请求数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-11 18:08:59
     */
    pullData() {
      // loading
      //调用加载中
      this.$emit('loadingHandle',true,"加载中...");
      shengya_lead().then(data => {
        if (data.code == 10002) {
          this.$toast(data.data.msg);
          return;
        }
        document.title = data.title;
        this.result = data;
        this.component = data.component;

        for(let i=0;i<this.component.length;i++){
            if(data.submit){
                if(this.component[i].type=='multiple'){
                    this.userInfo[this.component[i].name] = data.submit[this.component[i].name].split(',');
                }else{
                    this.userInfo[this.component[i].name] = data.submit[this.component[i].name];
                }
                
            }else{
                if(this.component[i].type=='multiple'){
                    this.userInfo[this.component[i].name] = [];
                }
            }
            
        }

        this.bodyShow = true;
        this.validationHandle();
        
        //关闭加载中
        this.$emit('loadingHandle',false);
      }).catch(()=>{
        //关闭加载中
        this.$emit('loadingHandle',false);
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss">
.ms-information {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: auto;
  top: 0;
  left: 0;
  background-color: #ffffff;
  padding: 40px 30px 0 30px;
  .ms-infor {
    // box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    // padding: 60px 30px;
    .h2 {
      font-size: 44px;
      font-weight:bold;
      color: #333333;
      margin-bottom: 50px;
    }
    .h3 {
      font-size: 34px;
      color: #333333;
      margin-bottom: 50px;
      font-weight: 400;
    }
    .h4 {
      font-size: 34px;
      color: #333333;
      margin-bottom: 15px;
      line-height: 1;
    }
    .infor-group {
      display: flex;
      flex-direction: column;
      position: relative;
      margin-bottom: 30px;
      
      input[type="text"] {
        border: 2px solid #cccccc;
        border-radius: 8px;
        line-height: 70px;
        padding: 0 20px;
        font-size: 26px;
      }
    }
  }
  //   提价按钮组
  .submit-group {
    margin: 80px auto 108px;
    font-size: 32px;
    display: flex;
    justify-content: center;
    .skip {
      display: block;
      width: 174px;
      text-align: center;
      line-height: 64px;
      color: #eb5032;
      border-radius: 32px;
      border: 2px solid #eb5032;
      margin-right: 80px;
    }
    .submitBtn {
      display: block;
      width: 174px;
      text-align: center;
      line-height: 64px;
      color: #ffffff;
      border-radius: 32px;
      background-color: #cccccc;
    }
    .submitBtn.on {
      background-color: #eb5032;
    }
  }
}
// 复选框
  .checkbox {
    margin-top: 60px;
    color: #333333;
    .familiarity {
      display: flex;
      color: #333333;
      flex-direction: column;
      font-size: 32px;
      .checkbox-group {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        line-height: 42px;
        &:last-child {
          margin-bottom: 0px;
        }
        label {
          line-height: 42px;
        }
        label.checkbox-text {
          font-size: 30px;
          flex: 1;
        }
        .other {
          width: 544px;
          padding: 0 20px;
          box-sizing: border-box;
          line-height: 70px;
          border-radius: 8px;
          border: 1px solid #cccccc;
        }
        label.icon {
          display: block;
          position: relative;
          width: 34px;
          height: 34px;
          border: 2px solid #cccccc;
          box-sizing: border-box;
          background-color: #ffffff;
          border-radius: 4px;
          margin-right: 25px;
          input[type="checkbox"] {
            display: none;
            border: 0;
            outline: 0 !important;
            background-color: transparent;
            -webkit-appearance: none;
          }
        }
        label.icon.on {
          background: url(../../assets/press.png) center no-repeat;
          background-size: 100% 100%;
          border: none;
        }
      }
    }
  }
</style>